import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, IconButton, styled, Tab, Tabs, Typography } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { useEffect, useState } from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ReactComponent as DeleteIcon } from "../../../assets/Images/Delete.svg";
import { ReactComponent as EditIcon } from "../../../assets/Images/EditIcon.svg";
import { ReactComponent as MessageIcon } from "../../../assets/Images/Message.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/Images/Phone.svg";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import { ReactComponent as SuccessIcon } from "../../../assets/Images/SuccessProjectIcon.svg";
import {
  getCustomWriteAccess,
  hasCallHistoryAccess,
  hasCampaignsAccess,
} from "../CommonComponents/Common";
import CommonPopup from "../CommonComponents/PopUpCards/CommonPopup";
import DeletePopup from "../CommonComponents/PopUpCards/DeletePopUp";
import DynamicTable from "../CommonComponents/Table/DynamicTable";
import {
  deleteAgentAction,
  editDataReducerActiom,
  getAgentAction,
  getChatIdAgentAction,
  handleChatAgentAction,
  handleEditChatAgentAction,
  setDefaultAgentAction,
} from "../ProjectSection/Agents/Store/Agent.action";
import { addNotificationAction } from "../Store/Account/Account.action";
import AgentHeader from "./AgentHeader";
import Agent from "./AgentModal/Agent";
import TestAgent from "./TestAgent";
import TestProgress from "./TestProgress";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import { Gauge, GitBranch, UserCheck } from "lucide-react";
import { getCallSettingAction } from "../ProjectSection/CallSettings/Store/callSetting.action";
import { axiosClient } from "../../../Constant/apiConstant";
const VersionModal = React.lazy(() => import("./VersionBody"));
const ChatModal = React.lazy(() => import("./ChatBody"));
const DemoCallModal = React.lazy(() => import("./DemoCallBody"));
const TestCallModal = React.lazy(() => import("./CallTestBody"));

const agentTypes = ["call", "email", "sms"];

const AgentMenuItem = ({
  icon,
  title,
  subtitle,
  onClick,
  danger = false,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  onClick: () => void;
  danger?: boolean;
}) => {
  return (
    <MenuItem
      onClick={onClick}
      sx={{
        minWidth: 240,
        gap: 0.5,
        py: 1,
        borderBottom: "1px solid #E5E7EB",
        "&:last-child": { borderBottom: "none" },
      }}
    >
      <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>

      <ListItemText>
        <Typography
          variant="body2"
          sx={{ color: danger ? "#DC2626" : "text.primary", fontWeight: 500 }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: "#6B7280" }}>
            {subtitle}
          </Typography>
        )}
      </ListItemText>
    </MenuItem>
  );
};

const AgentList = () => {
  const dispatch = useDispatch();
  const reducer: any = useSelector((state) => state);
  const { projectId: paramProjectId } = useParams<{ projectId: string }>();

  const {
    AgentReducer: { agents },
    CallSettingReducer: { callSettings },
    ProjectReducer: { projectList },
    AccountReducer: {
      constantData,
      userDetails: { email },
      selectedAccount,
      accountRoles,
    },
  } = reducer;

  const hasRestrictedCallHistoryAccess = hasCallHistoryAccess(accountRoles);
  const hasRestrictedCampaignsAccess = hasCampaignsAccess(accountRoles);
  const hasRestrictedAccess =
    hasRestrictedCallHistoryAccess || hasRestrictedCampaignsAccess;
  const accessedProjectIds =
    hasRestrictedAccess && projectList?.map((p) => p._id);

  const projectId = hasRestrictedAccess
    ? accessedProjectIds[0]
    : paramProjectId;

  const [state, setState] = useState({
    agentList: [],
    selectedRadioId: "",
    callTest: false,
    show: false,
    spin: false,
    selectedAgent: {},
    chatModal: false,
    chatId: "",
    chatShow: false,
    selectedId: "",
  });
  const {
    agentList,
    selectedRadioId,
    callTest,
    show,
    spin,
    selectedAgent,
    chatModal,
    chatId,
    chatShow,
    selectedId,
  } = state;
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [menuRow, setMenuRow] = useState<any>(null);
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState<any>([]);
  const [history, setHistory] = useState<any>([]);
  const [inputText, setInputText] = useState("");
  const [saveSpin, setSaveSpin] = useState(false);
  const [editedIndex, setEditedIndex] = useState("");
  const [showAgentModal, setShowAgentModal] = useState(false);
  const [testAgentModal, setTestAgentModal] = useState(false);
  const [testProgressModal, setTestProgressModal] = useState(false);
  const [successState, setSuccessState] = useState({
    successPopup: false,
    successPopupHeading: "",
    successPopupMessage: "",
  });
  const [demoCallModal, setDemoCallModal] = useState(false);
  const [versionModal, setVersionModal] = useState(false);
  const { successPopup, successPopupHeading, successPopupMessage } =
    successState;

  useEffect(() => {
    setLoading(true);
    setState((prev) => ({
      ...prev,
      agentList: agents,
    }));
    setLoading(false);
  }, [agents]);

  useEffect(() => {
    const init = async () => {
      if (hasRestrictedAccess) {
        axiosClient.defaults.headers.common["projectId"] = projectId;
        await dispatch(getAgentAction(projectId));
        await dispatch(getCallSettingAction(projectId));
      }
    };
    if (projectId) init();
  }, [projectId]);

  const handleDefault = async (id) => {
    setState((prev) => ({
      ...prev,
      selectedRadioId: id,
    }));
    const obj = {
      agentId: id,
    };
    const defaultAgentRes: any = await dispatch(
      setDefaultAgentAction(obj, projectId)
    );

    if (defaultAgentRes === 200) {
      setSuccessState((prev) => ({
        ...prev,
        successPopup: true,
        successPopupHeading: "Default Agent",
        successPopupMessage: "Default Agent selected successfully",
      }));
    }
    await dispatch(getAgentAction(projectId));
    setState((prev) => ({
      ...prev,
      selectedRadioId: "",
    }));
  };

  const callToggle = (agentPar) => {
    if (agentPar) {
      setState((prev) => ({
        ...prev,
        selectedAgent: agentPar,
        callTest: !prev.callTest,
      }));
    }
  };

  const demoCallToggle = (agentPar) => {
    if (agentPar) {
      setState((prev) => ({
        ...prev,
        selectedAgent: agentPar,
      }));
      setDemoCallModal(true);
    }
  };

  const toggleModal = () => {
    setMessages([]);
    setHistory([]);
    setInputText("");
    setState((prev) => ({
      ...prev,
      chatId: "",
      chatShow: false,
      chatModal: false,
    }));
  };

  const handleTestBot = async (agent) => {
    setState((prev) => ({
      ...prev,
      chatModal: true,
    }));
    let obj = {
      examples: agent?.conversationData,
      agent_name: agent?.agentName,
      organization_name: agent?.organisationName,
      greeting_message: agent?.greetingMessage,
      context: agent?.context,
      rules: agent?.rules,
    };
    let res: any = await dispatch(getChatIdAgentAction(obj));
    let obj1 = {
      prompt: res?._id,
      output: "text",
      voice: callSettings?.voice,
      asr: callSettings?.asrEngine,
      question: "Hi",
      history: history,
      temperature: callSettings?.temperature || "0.2",
      model: callSettings?.model || "001",
      stream: callSettings?.stream || false,
    };

    let res1: any = await dispatch(handleChatAgentAction(obj1));
    const botResponse = {
      id: messages?.length + 2,
      text: res1?.response,
      timestamp: new Date().toLocaleTimeString(),
      isUser: false,
    };
    setMessages([...messages, botResponse]);

    setHistory([
      ...history,
      {
        content: "Hi",
        author: "user",
      },
      {
        content: res1?.response,
        author: "bot",
      },
    ]);
    setState((prev) => ({
      ...prev,
      chatId: res?._id,
      chatShow: true,
    }));
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    let inputText1 = inputText;
    if (inputText.trim() === "") {
      return;
    }
    const userMessage = {
      id: messages.length + 1,
      text: inputText1,
      timestamp: new Date().toLocaleTimeString(),
      isUser: true,
    };

    let obj = {
      prompt: chatId,
      output: "text",
      voice: callSettings?.voice,
      asr: callSettings?.asrEngine,
      question: inputText1,
      history: history,
      temperature: callSettings?.temperature || "0.2",
      model: callSettings?.model || "001",
      stream: callSettings?.stream || false,
    };
    setHistory([
      ...history,
      {
        content: inputText1,
        author: "user",
      },
    ]);
    setMessages([...messages, userMessage]);
    setInputText("");
    let res: any = await dispatch(handleChatAgentAction(obj));
    const botResponse = {
      id: messages.length + 2,
      text: res.response,
      timestamp: new Date().toLocaleTimeString(),
      isUser: false,
    };
    setMessages([...messages, userMessage, botResponse]);
    setHistory([
      ...history,
      {
        content: inputText1,
        author: "user",
      },
      {
        content: res.response,
        author: "bot",
      },
    ]);
  };

  const handleDelete = (id) => {
    setState((prev) => ({
      ...prev,
      selectedId: id,
      show: true,
    }));
  };

  const confirmDelete = async () => {
    setState((prev) => ({
      ...prev,
      spin: true,
    }));

    let res: any = await dispatch(deleteAgentAction(selectedId));
    await dispatch(getAgentAction(projectId));
    setState((prev) => ({
      ...prev,
      selectedId: "",
      spin: false,
      show: false,
    }));
    if (res) {
      setSuccessState((prev) => ({
        ...prev,
        successPopup: true,
        successPopupHeading: "Agent Deleted",
        successPopupMessage: "Agent deleted successfully",
      }));
    }
  };

  const toggle = () => {
    setState((prev) => ({
      ...prev,
      show: !prev.show,
    }));
  };

  const handleEdit = async (agent) => {
    await dispatch(editDataReducerActiom(agent));
    setShowAgentModal(true);
  };

  const handleSaveEditMessage = async () => {
    if (history.length > 2) {
      setSaveSpin(true);
      let obj = { chat: history };
      await dispatch(handleEditChatAgentAction(obj, chatId));
      setEditedIndex("");
      setSaveSpin(false);
    } else
      dispatch(
        addNotificationAction("Conversation length is short", "warning")
      );
  };

  let propsObj = {
    editedIndex,
    setEditedIndex,
    handleSaveEditMessage,
    constantData,
    email,
    saveSpin,
  };

  const openRowMenu = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const closeRowMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const filterAgentsByType = () => {
    const selectedType = agentTypes[value];
    if (selectedType === "call") {
      return agentList.filter(
        (agent: any) => !agent.agentType || agent.agentType === "call"
      );
    }
    return agentList.filter((agent: any) => agent.agentType === selectedType);
  };

  const handleTest = (agent) => {
    setTestAgentModal(true);
    if (agent) {
      setState((prev) => ({
        ...prev,
        selectedAgent: agent,
      }));
    }
  };

  const handleTestAgent = (agent) => {
    setTestProgressModal(true);
    if (agent) {
      setState((prev) => ({
        ...prev,
        selectedAgent: agent,
      }));
    }
  };

  const accessMode = getCustomWriteAccess(reducer);
  const isWrite = accessMode === "write";
  const isRead = accessMode === "read";

  return (
    <Box>
      <Box>
        <AgentHeader
          callHistoryAccess={hasRestrictedAccess}
          handleAgentModal={() => setShowAgentModal(true)}
        />
        {selectedAccount?.params?.multiAgent && (
          <AgentTabs
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            slotProps={{
              indicator: {
                style: {
                  backgroundColor:
                    filterAgentsByType()?.length > 0 ? "#fff" : "#D1D9EF",
                  borderWidth: "1px",
                },
              },
            }}
            $hasAgents={filterAgentsByType()?.length > 0}
          >
            <AgentTab label="Call Agent" />
            <AgentTab label="Email Agent" />
            <AgentTab label="SMS Agent" />
          </AgentTabs>
        )}

        <Box>
          <DynamicTable
            columns={[
              {
                label: "NAME",
                field: "agentName",
              },
              {
                label: "ORGANISATION NAME",
                field: "organisationName",
                styles: { padding: 2 },
              },
              {
                label: "ACTIONS",
                render: (row) => (
                  <>
                    {hasRestrictedAccess && !getCustomWriteAccess(reducer) && (
                      <Box className="flex-xy-center" gap={1.5}>
                        <PhoneIcon
                          title="Agent Call"
                          onClick={() => callToggle(row)}
                          className="cursor-pointer"
                        />
                        <MessageIcon
                          title="Agent Chat"
                          onClick={() => handleTestBot(row)}
                          className="cursor-pointer"
                        />
                      </Box>
                    )}
                    {getCustomWriteAccess(reducer) === "write" && (
                      <Box className="flex-xy-center" gap={1.5}>
                        <PhoneIcon
                          title="Agent Call"
                          onClick={() => callToggle(row)}
                          className="cursor-pointer"
                        />
                        <MessageIcon
                          title="Agent Chat"
                          onClick={() => handleTestBot(row)}
                          className="cursor-pointer"
                        />
                        {!hasRestrictedAccess && (
                          <>
                            <EditIcon
                              title="Edit Agent"
                              onClick={() => handleEdit(row)}
                              className="cursor-pointer"
                            />
                            <button
                              title="Select default agent"
                              onClick={() => handleDefault(row?._id)}
                              className="cursor-pointer"
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                              }}
                            >
                              {" "}
                              {selectedRadioId === row?._id ? (
                                <Spinner size={"sm"} />
                              ) : (
                                <input
                                  type="radio"
                                  className="cursor-pointer"
                                  checked={row?.default}
                                  readOnly
                                  style={{ marginTop: "2px" }}
                                />
                              )}
                            </button>
                            <IconButton
                              aria-label="more"
                              aria-controls={
                                menuAnchorEl ? "agent-row-menu" : undefined
                              }
                              aria-haspopup="true"
                              onClick={(e) => openRowMenu(e as any, row)}
                              size="small"
                              sx={{ p: 0 }}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </>
                        )}
                      </Box>
                    )}
                    {getCustomWriteAccess(reducer) === "read" && (
                      <Box className="flex-xy-center gap-1">
                        <MessageIcon
                          title="Agent Chat"
                          onClick={() => handleTestBot(row)}
                          className="cursor-pointer"
                        />
                        {hasRestrictedAccess && (
                          <PhoneIcon
                            title="Agent Call"
                            onClick={() => callToggle(row)}
                            className="cursor-pointer"
                          />
                        )}
                        {!hasRestrictedAccess && (
                          <EditIcon
                            title="Edit Agent"
                            onClick={() => handleEdit(row)}
                            className="cursor-pointer"
                          />
                        )}
                      </Box>
                    )}

                    <Menu
                      id="agent-row-menu"
                      anchorEl={menuAnchorEl}
                      open={Boolean(menuAnchorEl) && menuRow?._id === row?._id}
                      onClose={closeRowMenu}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                      MenuListProps={{
                        sx: { paddingY: 0 },
                      }}
                    >
                      <Box>
                        <AgentMenuItem
                          icon={<UserCheck size={18} />}
                          title="Test Agent"
                          subtitle="Run quick test for this agent"
                          onClick={() => {
                            handleTest(row);
                            closeRowMenu();
                          }}
                        />

                        <AgentMenuItem
                          icon={<Gauge size={18} />}
                          title="Test Agent Progress"
                          subtitle="View progress of ongoing tests"
                          onClick={() => {
                            handleTestAgent(row);
                            closeRowMenu();
                          }}
                        />

                        <AgentMenuItem
                          icon={<GitBranch size={18} />}
                          title="Agent Versions"
                          subtitle="See saved versions & restore if needed"
                          onClick={() => {
                            setState((prev) => ({
                              ...prev,
                              selectedAgent: row,
                            }));
                            setVersionModal(true);
                            closeRowMenu();
                          }}
                        />

                        <AgentMenuItem
                          icon={<LinkOutlinedIcon fontSize="small" />}
                          title="Demo Link"
                          subtitle="Create a demo link"
                          onClick={() => {
                            demoCallToggle(row);
                            closeRowMenu();
                          }}
                        />

                        <AgentMenuItem
                          icon={<DeleteIcon />}
                          title="Delete Agent"
                          subtitle="Permanently remove this agent"
                          danger
                          onClick={() => {
                            handleDelete(row?._id);
                            closeRowMenu();
                          }}
                        />
                      </Box>
                    </Menu>
                  </>
                ),
              },
            ]}
            data={filterAgentsByType()}
            showTotalRows={true}
            pagination={false}
            loading={loading}
            handlePageChange={() => ""}
            noDataAvailableMessage={"No Agents Available"}
            rowCount={filterAgentsByType()?.length}
          />
        </Box>
      </Box>
      {show && (
        <DeletePopup
          show={show}
          toggle={toggle}
          message={"Are you sure you want to delete the selected Agent ?"}
          handleDelete={confirmDelete}
          spin={spin}
          heading="Delete Agent"
        />
      )}

      {testAgentModal && (
        <TestAgent
          selectedAgent={selectedAgent}
          testAgentModal={testAgentModal}
          toggle={() => setTestAgentModal(false)}
          toggleTestAgentPopup={() =>
            setSuccessState((prev) => ({
              ...prev,
              successPopup: true,
              successPopupHeading: "Agent Test",
              successPopupMessage: "Agent Test started successfully",
            }))
          }
        />
      )}

      {testProgressModal && (
        <TestProgress
          selectedAgent={selectedAgent}
          testProgressModal={testProgressModal}
          toggle={() => setTestProgressModal(false)}
        />
      )}

      {callTest && (
        <TestCallModal
          projectId={projectId}
          setMainState={setState}
          setSuccessState={setSuccessState}
          selectedAgent={selectedAgent}
          callTest={callTest}
          callToggle={callToggle}
        />
      )}
      {demoCallModal && (
        <DemoCallModal
          projectId={projectId}
          selectedAccount={selectedAccount}
          selectedAgent={selectedAgent}
          setDemoCallModal={setDemoCallModal}
          demoCallModal={demoCallModal}
          setSuccessState={setSuccessState}
        />
      )}
      {chatModal && (
        <ChatModal
          inputText={inputText}
          setInputText={setInputText}
          handleSendMessage={handleSendMessage}
          chatShow={chatShow}
          messages={messages}
          chatModal={chatModal}
          toggleModal={toggleModal}
        />
      )}
      {showAgentModal && (
        <Agent
          agentTypes={agentTypes}
          agentStep={value}
          show={showAgentModal}
          onClose={() => setShowAgentModal(false)}
          setSuccessState={setSuccessState}
        />
      )}

      {versionModal && (
        <VersionModal
          dispatch={dispatch}
          selectedAgent={selectedAgent}
          selectedAccount={selectedAccount}
          setVersionModal={setVersionModal}
          agents={agents}
          setState={setState}
          versionModal={versionModal}
        />
      )}

      {successPopup && (
        <CommonPopup
          message={successPopupMessage}
          show={successPopup}
          toggle={() =>
            setSuccessState((prev) => ({
              ...prev,
              successPopup: false,
              successPopupHeading: "",
              successPopupMessage: "",
            }))
          }
          Icon={SuccessIcon}
          heading={successPopupHeading}
        />
      )}
    </Box>
  );
};

export default AgentList;

const AgentTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== "$hasAgents",
})<{ $hasAgents: boolean }>({
  minHeight: "40px",
  "& .MuiTabs-flexContainer": {
    justifyContent: "flex-start",
  },
  "& .MuiTab-root": {
    borderBottom: `1px solid ${"#D1D9EF"}`,
  },

  variants: [
    {
      props: ({ $hasAgents }) => $hasAgents,

      style: {
        "& .MuiTab-root": {
          borderBottom: {
            borderBottom: "#fff",
          },
        },
      },
    },
  ],
});

const AgentTab = styled(Tab)(({ theme }) => ({
  width: "auto",
  borderBottom: "1px solid #D1D9EF",
  minHeight: "40px",
  color: "#666666",
  fontSize: "14px",
  fontWeight: 500,
  textTransform: "none",
  padding: "0px 12px",
  "&.Mui-selected": {
    color: "#181818",
    backgroundColor: "#F8FAFE",
    border: "1px solid #D1D9EF",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
}));
